import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "display" }
const _hoisted_3 = { class: "lang" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "options" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: _ctx.selectedLanguage.toUpperCase()
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          src: _ctx.getLanguageIcon(_ctx.selectedLanguage)
        }, null, 8, _hoisted_5)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "dropdown-icon" }, "▼", -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
        return (_openBlock(), _createElementBlock("div", {
          key: lang.value,
          class: "option",
          onClick: ($event: any) => (_ctx.selectLanguage(lang))
        }, [
          _createTextVNode(_toDisplayString(lang.toUpperCase()) + " ", 1),
          _createElementVNode("img", {
            src: _ctx.getLanguageIcon(lang)
          }, null, 8, _hoisted_8)
        ], 8, _hoisted_7))
      }), 128))
    ])
  ]))
}